import styled from 'styled-components'

export function makeClickableContent (element) {
  return styled(element)`
    &:hover {
      text-decoration: none;
    }
  `
}

export default makeClickableContent